<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalTutorBillingChangeRequest } from '../../model/modal-tutor-billing-change-request.hook'
import TutorBillingModalHeader from '../TutorBillingModalHeader.vue'
import TutorBillingFieldsTable from '../TutorBillingFieldsTable.vue'

defineOptions({
  name: 'ModalTutorBillingChangeRequest',
})

const {
  isOpen,
  isSaving,
  hasPendingChangeRequest,
  title,
  subtitle,
  comment,
  columns,
  rows,
  setClose,
  setKeepAsIs,
  setConfirm,
} = useModalTutorBillingChangeRequest()
</script>

<template>
  <ModalDefault
    :show="isOpen"
    :loading="isSaving"
    class-name="modal-tutor-billing-change-request"
    is-close-button
    @click:overlay="setClose"
    @click:close="setClose"
  >
    <TutorBillingModalHeader
      :title="title"
      :subtitle="subtitle"
      :note="comment"
      :badge="hasPendingChangeRequest ? 'Change requested' : null"
    />
    <TutorBillingFieldsTable
      v-if="hasPendingChangeRequest"
      :columns="columns"
      :rows="rows"
    />
    <AppText
      v-else
      name="body1"
      color="slate-500"
    >
      No pending change request
    </AppText>
    <template #controls>
      <template v-if="hasPendingChangeRequest">
        <BtnPrimary
          text="Confirm new billing info"
          color="emerald"
          :disabled="isSaving"
          @click="setConfirm"
        />
        <BtnSecondary
          text="Keep info as is"
          :disabled="isSaving"
          @click="setKeepAsIs"
        />
      </template>
      <template v-else>
        <BtnSecondary
          text="Close"
          :disabled="isSaving"
          @click="setClose"
        />
      </template>
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalTutorBillingChangeRequest.scss" />
